import React from 'react';

import { NextPageWithLayout } from 'next';

import { AppDownloadSection } from '../../../components/AppDownloadSection/AppDownloadSection';
import { Container } from '../../../components/Container/Container';
import { MetaTags } from '../../../components/MetaTags/MetaTags';
import { CircleImageAndText } from '../components/CircleImageAndText';

import phoneFour from './assets/phoneFour.png';
import phoneOne from './assets/phoneOne.png';
import phoneThree from './assets/phoneThree.png';
import phoneTwo from './assets/phoneTwo.png';
import { HeaderSection } from '../components/HeaderSection';
import {
  META_FISHID_TITLE,
  META_FISHID_DESCRIPTION,
  META_FISHID_CANONICAL,
} from '../../../constants/metadata';

export const FishIdentifierPage: NextPageWithLayout = () => {
  const headerDescription = `With over 30,000 species of fish, it's easy to not always know what's exactly on the end of your line. 
  Until now. With Fishbrain you also have a fish identifier app included for free. When you take a photo of a fish, 
  Fishbrain can tell you which species of fish you caught, along with several other similar species. 
  FishID is perfect if you’re looking to log new species, curious about a previous catch, or when fishing for species with similar attributes, 
  but different regulations.`;

  return (
    <Container className="p-0 sm:p-0 md:p-0">
      <MetaTags
        title={META_FISHID_TITLE}
        description={META_FISHID_DESCRIPTION}
        link={META_FISHID_CANONICAL}
      />

      <HeaderSection
        headingText="Fish Identifier - ID what fish you caught"
        bodyText={headerDescription}
        bodyClassName="md:w-col-10"
      />

      <CircleImageAndText
        imgSrc={phoneOne}
        imgRight
        imgAlt="Upload a photo in the Fishbrain app to identify a fish"
        headingText="Upload a photo of that monster you caught"
        bodyText="Can’t remember what you caught during your last trip? Unsure of what’s on your line right now and what the regulations are for it? Tap the “+” icon at the bottom center of your screen and choose from your phone’s photo library, or snap a quick shot of the lunker you have on the end of your line. You can upload your fish photo as an individual function, or as part of the catch logging process. Make sure the colors, patterns and fins are present in your photo."
      />

      <CircleImageAndText
        imgSrc={phoneTwo}
        imgAlt="Select the water you caught the fish in"
        headingText="Select the water"
        bodyText="When the map screen pulls up, you can select the body of water you caught your fish in. This step is completely confidential and only used to narrow down the reasonable species that you could have caught based on location data and machine learning."
      />

      <CircleImageAndText
        imgSrc={phoneThree}
        imgRight
        imgAlt="Fishbrain app starts analyzing the image"
        headingText="Image analyzing"
        bodyText="Using specific learning models that identify colors, body patterns, fin shape/placement and the body of water you selected. Combining this learned data, Fishbrain can ID your fish from a pool of over 300 of the most popular sportfish in the world."
      />

      <CircleImageAndText
        imgSrc={phoneFour}
        imgAlt="Fishbrain app shows the identified fish"
        headingText="ID your species"
        bodyText="Your species will be identified to the closest known species in your area, with a picture and the fish’s full description from our database. Because of the individual variations in individual fish, you will also get a list of the next closest possible species from the catch area as well. This is particularly helpful in species with slight variations between them, like sunfish, trout and some bass species. Our FishID feature has a 99% accuracy rate in detecting the top 5 species."
      />

      <AppDownloadSection
        headlineText="Download Fishbrain and fish smarter today"
        sublineText="Unlimited access to the best fishing spot finder and fish identifier in the game. Get all the fishing intel you need to start catching more, and bigger, fish."
      />
    </Container>
  );
};
